import React, {useState} from 'react';
import {StatesButtonStates} from 'wix-ui-tpa';
import {AdditionalDetailsStepDataHook} from '../AdditionalDetailsStep';
import {NextStepButton} from '../../../StepsManager/Components/NextStepButton/NextStepButton';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../../Widget/ControllerContext';

export const AdditionalDetailsStepOpen = () => {
  const localeKeys = useLocaleKeys();
  const [isStepTransition, setIsStepTransition] = useState(false);

  const {
    formsStore: {goToNextStep},
  } = useControllerProps();

  const onStepTransition = () => {
    setIsStepTransition(true);
    goToNextStep();
  };

  return (
    <div data-hook={AdditionalDetailsStepDataHook.open}>
      <NextStepButton
        onClick={onStepTransition}
        text={localeKeys.checkout.continue_button_label()}
        dataHook={AdditionalDetailsStepDataHook.continueButton}
        disabled={isStepTransition}
        buttonState={
          isStepTransition ? /* istanbul ignore next */ StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE
        }
      />
    </div>
  );
};
